import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { AnalyzeEffects } from '@appStore/analyze/effects/analyze.effects';

export const effects: any[] = [AnalyzeEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class AnalyzeEffectsModule {}
